import React from 'react';
import BaseFactory from './BaseFactory';
import {
  getBlogAnchorTag,
  getFaqsAnchorTag,
  hasLocationHours,
  getNearbySolvPartner,
  NoTopMarginParagraph,
  NoBottomMarginParagraph,
  hasCustomDescription,
} from './util';
import { isEmptyObject } from '../../../core/util/object';
import CustomDescriptionSection from './CustomDescriptionSection';
import { SOLV_SECTION_TITLE } from './constants';

class NonPartnerPrimaryCare extends BaseFactory {
  constructor(location, nearbyLocations, properties) {
    super(location, properties);
    this.clinicsToChooseFrom = [];

    // nearby solv location
    if (!isEmptyObject(nearbyLocations)) {
      this.nearbyLocations = nearbyLocations;
      const nearbyClinics = nearbyLocations.nearby;
      const nearbySolvPartner = getNearbySolvPartner(nearbyClinics);

      // general nearby locations (solv partner or not)
      this.clinicsToChooseFrom = [...nearbyClinics];
      if (!isEmptyObject(nearbySolvPartner)) {
        this.clinicsToChooseFrom.shift();
      }
    }
  }

  getDescription() {
    return (
      `${this.clinicName} is a primary care clinic ` +
      `located at ${this.address}, ${this.city}, ` +
      `${this.state}, ${this.zip} and provides general, family medical care including ` +
      'preventative care, physicals, chronic condition treatment and more. For more ' +
      `information, call ${this.clinicName}${this.phoneString}.`
    );
  }

  getKeywords() {
    return (
      `${this.clinicName}, ${this.clinicName}, ${this.city}, ${this.clinicName} ${this.zip}, ` +
      `primary care ${this.city}, primary care ${this.zip}, ` +
      `walk-in clinic ${this.city}, walk-in clinic ${this.zip}, ${this.city} ${this.state} ` +
      `walk-in clinic, ${this.zip} walk-in clinic`
    );
  }

  getBody() {
    return (
      <div>
        <CustomDescriptionSection location={this.location} />
        <NoTopMarginParagraph>
          {hasCustomDescription(this.location) && (
            <span>
              {SOLV_SECTION_TITLE}
              <br />
            </span>
          )}
          Serving as a primary care provider in the {this.cityAnchorTag} area, {this.clinicName}{' '}
          sees mostly an appointment-driven patient population, however, they may support walk-in
          patients during certain hours.{' '}
          {hasLocationHours(this.location) ? (
            <span>
              It appears as though their practice is routinely open {this.numDaysOpenString} a week
              at their clinic{' '}
            </span>
          ) : (
            <span>Their clinic is </span>
          )}
          located at {this.fullAddress}
          {hasLocationHours(this.location) && (
            <span>
              {' '}
              with {this.nextOpenDayName}'s hours being {this.nextOpenDayHoursStr}
            </span>
          )}
          . It is certainly best to call the clinic to schedule an appointment, or ask about walk-in
          availability.
        </NoTopMarginParagraph>
        <NoBottomMarginParagraph>
          If you are looking to learn more about primary care including statistics, trends,{' '}
          {getFaqsAnchorTag()} and other useful information, check out our {getBlogAnchorTag()} to
          empower your knowledge as a healthcare consumer. {this.cityGuideContent}
        </NoBottomMarginParagraph>
      </div>
    );
  }
}

export default NonPartnerPrimaryCare;
